import React, { useState, useEffect, useRef, useContext } from 'react'
import { FormattedDate } from 'react-intl'
import Icon from 'components/Icon'
import Select from 'react-select'
import messages from "./messages";
import { FormattedMessage, useIntl } from 'react-intl'

const Filters = ({ onChange, filters, onClear }) => {
  const [customerOptions, setCustomerOptions] = useState([])
  const [contactOptions, setContactOptions] = useState([])
  const [templateOptions, setTemplateOptions] = useState([])
  const { formatMessage } = useIntl()

  const stageOptions = [
    { value: 'PENDING', label: 'Pending' },
    { value: 'READY', label: 'Ready' },
    { value: 'CLOSED', label: 'Completed' },
    { value: 'IN_PROGRESS', label: 'Recording' },
  ]

  useEffect(() => {
    fetch(`/rest/v2/customer`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then(({ data }) => {
        setCustomerOptions(data.map(({ uid, name }) => ({ label: name, value: uid })))
        setContactOptions(data
          .flatMap(({ contacts }) => contacts)
          .filter((obj, pos, arr) => arr.map((mapObj) => mapObj.uid).indexOf(obj.uid) === pos)
          .map(({ name, uid }) => ({ label: name, value: uid }))
        )
      })

    fetch(`/rest/v2/template`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then(({ data }) => setTemplateOptions(
        data
          .filter(({ meta: { parentId } }) => !parentId)
          .map(({ meta: { name, id } }) => ({
          value: id,
          label: name,
        }))
      ))
  }, [])

  const { stage = null, customerId = [], contactId = [], template = null } = filters

  return (
    <div className="w-full grow px-6 py-4 flex items-center space-x-4">
      <Icon icon="filter" />

      <Select
        isClearable
        placeholder={formatMessage(messages.branches)}
        isMulti
        className="pl-3 w-1/4 text-sm text-gray-600"
        value={customerOptions.filter(({ value }) => customerId.includes(value))}
        onChange={(values) => onChange({ ...filters, customerId: values.map(({ value }) => value) })}
        openMenuOnFocus
        options={customerOptions}
      />

      <Select
        isClearable
        placeholder={formatMessage(messages.contact)}
        isMulti
        className="pl-3 w-1/4 text-sm text-gray-600"
        value={contactOptions.filter(({ value }) => contactId.includes(value))}
        onChange={(values) => onChange({...filters, contactId: values.map(({ value }) => value) })}
        openMenuOnFocus
        options={contactOptions}
      />

      <Select
        isClearable
        placeholder={formatMessage(messages.template)}
        className="pl-3 w-1/4 text-sm text-gray-600"
        value={templateOptions.find(({ value }) => template == value )}
        onChange={(event) => onChange({...filters, template: event ? event.value : null })}
        openMenuOnFocus
        options={templateOptions}
      />

      <Select
        isClearable
        placeholder={formatMessage(messages.stage)}
        className="pl-3 w-1/4 text-sm text-gray-600"
        value={stageOptions.find(({ value }) => stage == value )}
        onChange={(event) => onChange({ ...filters, stage: event ? event.value : null })}
        openMenuOnFocus
        options={stageOptions}
      />

      <Icon icon="times" className="hover:text-primary cursor-pointer" onClick={onClear} />
    </div>
  )
}

export default Filters
